import { render, staticRenderFns } from "./ArticleAuthor.vue?vue&type=template&id=d1a143b4&scoped=true&"
import script from "./ArticleAuthor.vue?vue&type=script&lang=ts&"
export * from "./ArticleAuthor.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleAuthor.vue?vue&type=style&index=0&id=d1a143b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a143b4",
  null
  
)

export default component.exports